export default __webpack_public_path__ + "static/media/polygon.cba7644c.svg";